import { FC, ReactElement } from 'react';

const MapSection: FC = (): ReactElement => {
  return (
    <section className="bg-slate-50 py-16">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-12 text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-sprimary">
            Our Clinics
          </span>
          <h2 className="mt-2 text-3xl font-bold text-slate-900">
            Choose Your Nearest Location
          </h2>
          <p className="mt-4 text-slate-600">
            The same trusted physiotherapy team, now across two convenient
            locations.
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          <article className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm transition hover:-translate-y-1 hover:shadow-lg">
            <div className="grid xs:grid-cols-1 gap-6 sm:grid-cols-2">
              <div>
                <div className="mb-6 flex items-center gap-3">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-neutral-100 text-sky-700">
                    <svg
                      className="h-6 w-6 fill-secondary"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M12 2C7.58 2 4 5.58 4 10c0 5.25 8 13 8 13s8-7.75 8-13c0-4.42-3.58-8-8-8zm0 11c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-slate-900">
                      Ilford Clinic
                    </h3>
                    <p className="text-sm text-slate-500">Main Clinic</p>
                  </div>
                </div>
                <address className="not-italic leading-7 text-slate-600">
                  132b Horns Road,
                  <br />
                  Ilford,
                  <br />
                  IG2 6BL
                </address>
                <a
                  href="https://maps.app.goo.gl/wr5ikkuSEvPW3CWE8"
                  className="mt-8 inline-flex items-center gap-2 rounded-xl bg-primary px-5 py-3 font-medium text-white transition hover:bg-sky-700 xs:block sm:hidden md:hidden w-fit"
                >
                  View on Map
                </a>
              </div>
              <div className="gmap_canvas xs:hidden sm:block md:block">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d619.8775834451437!2d0.08397148855521158!3d51.57720961502226!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a74b6038f7a1%3A0x4c42ab06cba426f3!2sFirst%20Care%20Physiotherapy%20%26%20Sports%20Clinic!5e0!3m2!1sen!2suk!4v1706826707690!5m2!1sen!2suk"
                  className="h-full pointer-events-auto"
                  width="100%"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </article>
          <article className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm transition hover:-translate-y-1 hover:shadow-lg">
            <div className="grid xs:grid-cols-1 gap-6 sm:grid-cols-2">
              <div>
                <div className="mb-6 flex items-center gap-3">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-neutral-100 text-sky-700">
                    <svg
                      className="h-6 w-6 fill-secondary"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M12 2C7.58 2 4 5.58 4 10c0 5.25 8 13 8 13s8-7.75 8-13c0-4.42-3.58-8-8-8zm0 11c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-slate-900">
                      Forrest Gate Clinic
                    </h3>
                    <p className="text-sm text-slate-500">New Clinic</p>
                  </div>
                </div>
                <address className="not-italic leading-7 text-slate-600">
                  67 Plashet Road,
                  <br />
                  London
                  <br />
                  E13 0QA
                </address>
                <a
                  href="https://maps.app.goo.gl/ZpMVQmmzFf6fWA6t6"
                  className="mt-8 inline-flex items-center gap-2 rounded-xl bg-primary px-5 py-3 font-medium text-white transition hover:bg-sky-700 xs:block sm:hidden md:hidden w-fit"
                >
                  View on Map
                </a>
              </div>
              <div className="gmap_canvas xs:hidden sm:block md:block">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.685534616545!2d0.02344317653697252!3d51.53732737182009!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a7bf98af2b7d%3A0xf24d3f57b051cdd!2s67%20Plashet%20Rd%2C%20London%20E13%200QA!5e0!3m2!1sen!2suk!4v1784712660393!5m2!1sen!2suk"
                  className="h-full pointer-events-auto"
                  width="100%"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
